export const DEFAULT_WIDTH = 550;
export const DEFAULT_MIN_WIDTH = 550;
export const DEFAULT_MIN_HEIGHT = 400;

// error codes
export const WORKFLOW_NOT_FOUND_CODE = 'WORKFLOW_NOT_FOUND';
export const NO_RESOURCE_PERMISSIONS = 'NO_RESOURCE_PERMISSIONS';

export const FEEDBACK_TRACKING_EVENT = 'ai_duo_agentic_chat_feedback_submitted';

export const TRACKING_EVENT_VIEW_EMPTY_STATE = 'view_dap_trial_or_paid_empty_state';
export const TRACKING_EVENT_CLICK_AGENT = 'click_dap_trial_or_paid_empty_state_agent';
export const TRACKING_EVENT_CLICK_PROMPT = 'click_dap_trial_or_paid_empty_state_prompt';
export const TRACKING_EVENT_CLICK_EXPLORE_AGENTS =
  'click_dap_trial_or_paid_empty_state_explore_agents_link';
